import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

class StatusTabs extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(status) {
    const { changeTab, isLoading } = this.props;
    !isLoading && changeTab(status);
  }

  render() {
    const { isLoading, selectedTab, stasuses: statusList, statusCount, isShowCount } = this.props;
    const mediumScreenClass =
      statusList.length > 3
        ? 'status-tab-width-sm-3 status-tab-width-lg-2'
        : 'status-tab-width-sm-3 status-tab-width-lg-3';
    const cursorClassName = isLoading ? '' : 'cursor-pointer';

    return (
      <div className="status-tabs d-flex pr-2 overflow-auto flex-wrap flex-md-nowrap">
        {statusList.map((status, index) => {
          const isSelected = selectedTab === status;
          const tabContent = (
            <div className="w-100 d-flex justify-content-between">
              <span
                className={classNames('h5 mb-0 ml-auto', {
                  'mr-auto': !isShowCount
                })}
              >
                {status.value}
              </span>
              {isShowCount && <span className="h6 mb-0 mt-1 ml-3 ml-md-2 mr-auto">({statusCount[index]})</span>}
            </div>
          );

          return (
            <div
              key={index}
              className={
                isSelected
                  ? `d-flex w-100 p-2 bg-400 ${mediumScreenClass} ${cursorClassName}`
                  : `d-flex w-100 p-2 ${mediumScreenClass} ${cursorClassName}`
              }
            >
              {status.linkTo === '#' ? (
                <button
                  type="button"
                  className="btn btn-link w-100 p-0 border-0 text-decoration-none"
                  aria-pressed={isSelected}
                  onClick={this.handleClick.bind(this, status)}
                >
                  {tabContent}
                </button>
              ) : (
                <Link
                  to={status.linkTo}
                  className="w-100 text-decoration-none"
                  aria-current={isSelected ? 'page' : undefined}
                  onClick={this.handleClick.bind(this, status)}
                >
                  {tabContent}
                </Link>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

StatusTabs.propTypes = {
  isLoading: PropTypes.bool,
  changeTab: PropTypes.func.isRequired,
  selectedTab: PropTypes.object.isRequired,
  stasuses: PropTypes.array.isRequired,
  statusCount: PropTypes.array,
  isShowCount: PropTypes.bool
};

StatusTabs.defaultProps = { isLoading: false };

export default StatusTabs;
